import { useTranslation } from 'react-i18next';

// "Include in What's New" opt-in shown on the add forms for bibliography,
// organizations and teaching materials. The flag is stored on the source
// row; a database trigger (migration 019) creates the What's New notice
// when the row is published and hides it again 30 days later.
export default function AnnounceCheckbox({ checked, onChange }) {
  const { t } = useTranslation();
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-white/10 bg-navy-base/30 p-4">
      <input
        type="checkbox"
        checked={Boolean(checked)}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 accent-gold"
      />
      <span>
        <span className="block text-sm font-medium text-cream">{t('whatsNew.announce.label')}</span>
        <span className="mt-0.5 block text-xs text-ink-secondary">{t('whatsNew.announce.hint')}</span>
      </span>
    </label>
  );
}
